const LoadingCapabilities = () => {
  // Uppercase
  return (
    <div className='content-left-box'>
      <h2 className='text-gray letter-scrambler'>{'\\\\LOADING CAPABILITIES\\\\'}</h2>
      <ul>
        <li className="text-loading-left letter-scrambler">{'< LOADING > CREATIVE_DIRECTION : OK'}</li>
        <li className="text-loading-left letter-scrambler">{'< LOADING > BRANDING_DESIGN : OK'}</li>
        <li className="text-loading-left letter-scrambler">{'< LOADING > INTERACTION_DESIGN : OK'}</li>
        <li className="text-loading-left letter-scrambler">{'< LOADING > CHARACTER_DESIGN : OK'}</li>
        <li className="text-loading-left letter-scrambler">{'< LOADING > MOTION_DESIGN : OK'}</li>
        <li className="text-loading-left letter-scrambler">{'< LOADING > PRODUCTION : OK'}</li>
        <li className="text-loading-left letter-scrambler">{'< LOADING > FRONT-END : OK'}</li>
        <li className="text-loading-left letter-scrambler">{'< LOADING > BACK-END : OK'}</li>
        <li className="text-loading-left letter-scrambler">{'< LOADING > UI/UX : OK'}</li>
        <li className="text-loading-left letter-scrambler">{'< LOADING > WEB_3.0 : OK'}</li>
      </ul>
      <p className='text-gray-no-margin'>{'/'}</p>
    </div>
  )
};

export default LoadingCapabilities
